import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import RaceDistance from "components/PastPerformances/CodedPPs/Parts/RaceDistance";
import PositionAtPoint from "components/PastPerformances/CodedPPs/Parts/PositionAtPoint";
import { transformViewDate } from "utils/date-utils";
import { toKilos } from "utils/number-utils";

import useStyles from "./styles";

interface IProps {
  pastPerformance: racehorse360.IHorseLastPastPerformance;
}

const PastPerformanceItem = (props: IProps) => {
  const { pastPerformance } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        {transformViewDate(pastPerformance.date, null, "dMMMyy")}
        {"-"}
        {pastPerformance.raceNumber}
        {pastPerformance.track}{" "}
        <RaceDistance
          distance={pastPerformance.raceDistance}
          unit={pastPerformance.raceDistanceUnit}
        />{" "}
        {pastPerformance.raceType}{" "}
        {Boolean(pastPerformance.claimedPriceUsa) &&
          `${toKilos(pastPerformance.claimedPriceUsa)} `}
        <PositionAtPoint
          position={pastPerformance.positionAtFinish}
          lengthAhead={pastPerformance.lengthAheadAtFinish}
          lengthBehind={pastPerformance.lengthBehindAtFinish}
        />
      </div>
      <div className={classes.comment}>{pastPerformance.comment}</div>
    </div>
  );
};

export default React.memo(PastPerformanceItem);
